import Card from '../../components/ui/Card'

function DocumentList({ documents }) {
  if (!documents.length) {
    return <div className="text-muted">No documents linked yet.</div>
  }

  const grouped = documents.reduce((acc, doc) => {
    const productName = doc.products?.name || 'General'
    acc[productName] = acc[productName] || {}
    acc[productName][doc.category] = acc[productName][doc.category] || []
    acc[productName][doc.category].push(doc)
    return acc
  }, {})

  return (
    <div className="stack">
      {Object.entries(grouped).map(([productName, categories]) => (
        <Card key={productName} className="doc-card">
          <Card.Header>
            <Card.Title>{productName}</Card.Title>
          </Card.Header>
          <Card.Body>
            <div className="doc-grid">
              {Object.entries(categories).map(([category, docs]) => (
                <div key={category}>
                  <h4>{category}</h4>
                  <ul className="list-compact">
                    {docs.map(doc => (
                      <li key={doc.id}>
                        <a href={doc.url} target="_blank" rel="noreferrer">{doc.title}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </Card.Body>
        </Card>
      ))}
    </div>
  )
}

export default DocumentList
